import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons/faTrashAlt";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconDelete: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faTrashAlt} />;
};
